const getImageType = () => {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
  const imageType = isMac ? 'format(jpg)' : 'format(webp)'

  return { imageType }
}

export default getImageType
